import { getQuery } from '@tencent/imutils/dist/esm/util_09_url';
import { isPC } from '@tencent/imutils/dist/esm/util_04_ua';
import { gradeList, subjectList, getClickId } from '../../lib/utils';

export function getGradeCode(gradeString) {
  for (const { key, value } of gradeList) {
    if (gradeString.includes(value)) {
      return key;
    }
  }

  return null;
}

export function getSubjectCode(subjectString) {
  for (const { key, value } of subjectList) {
    if (subjectString.includes(value)) {
      return key;
    }
  }

  return null;
}

export function formatCRMData(data) {
  const crmData = { flag: 1, ext_info: {} };

  Object.entries({
    // uin: getUin(),
    fr: getQuery('fr'),
    clickid: getClickId(),
    source_url: window.location.href,
    keyword: getQuery('keyword'),
    platform: isPC() ? 'pc' : 'h5',
  }).forEach(([key, value]) => {
    if (value) {
      crmData[key] = value;
    }
  });

  const result = data.reduce((accu, { key, value: v }) => {
    let value = v;
    if (Array.isArray(v) && v.length === 1) {
      value = v[0];
    }

    if (!['string', 'number', 'boolean'].includes(typeof value)) {
      return accu;
    }

    if (key === '手机号') {
      crmData.phone = value;
    }
    if (key === '验证码') {
      crmData.verify_code = parseInt(value, 10);
    }
    if (key.includes('年级')) {
      const grade = getGradeCode(value);
      if (grade) {
        crmData.grade = parseInt(grade, 10);
      }
    }
    if (key.includes('科目')) {
      const subject = getSubjectCode(value);
      if (subject) {
        crmData.subject = parseInt(subject, 10);
      }
    }

    accu.ext_info[key] = JSON.stringify(value);

    return accu;
  }, crmData);

  result.ext_info = JSON.stringify(result.ext_info);
  return result;
}

export function formatCRMTransferIntroData(data) {
  const crmData = {};
  const introUin = getQuery('u') || '';
  Object.entries({
    fr: getQuery('fr'),
    clickid: getClickId(),
    source_url: window.location.href,
    keyword: getQuery('keyword'),
    platform: isPC() ? 'pc' : 'h5',
    teacher_uin: getQuery('tu') || '',
    intro_uin: introUin,
    source_type: parseInt(getQuery('s'), 10) || 0,
    ctu: getQuery('ctu') || '',
    l: parseInt(getQuery('l'), 10) || 0,
    share_key: `${introUin}_${getQuery('st') || ''}`,
    share_channel: parseInt(getQuery('sc'), 10) || 0,
  }).forEach(([key, value]) => {
    if (value) {
      crmData[key] = value;
    }
  });

  const result = data.reduce((accu, { key, value: v }) => {
    let value = v;
    if (Array.isArray(v) && v.length === 1) {
      value = v[0];
    }
    if (!['string', 'number', 'boolean'].includes(typeof value)) {
      return accu;
    }
    if (key === '手机号') {
      crmData.phone = value;
    }
    if (key === '验证码') {
      crmData.verify_code = value;
    }
    if (key.includes('年级')) {
      const grade = getGradeCode(value);
      if (grade) {
        crmData.grade_list = grade;
      }
    }
    return accu;
  }, crmData);

  return result;
}
